<template>
  <v-dialog
    v-model="display"
    persistent
    width="450"
  >
    <v-card
      color="white"
      style="text-align:center;"
    >
      <div style="width:450px;height:130px;">
        <v-icon
          style="transform: rotate(-45deg);font-size:125px;margin:10px;"
          class="cc-icon"
          color="primary"
        >
          link
        </v-icon>
      </div>
      <v-card-text>
        <span style="font-weight:500;font-size:24px;">Update to {{ app_name }}</span><br /><br />
        <span>
          <i>Please pardon the interruption. An update to {{ app_name }} has been released that requires a page reload.</i>
        </span>
        <div v-if="pendingSaves > 0 && errorSaves == 0">
          <br /><br />
          <b>Waiting for {{pendingSaves}} questions to complete saving...</b>
        </div>
        <div
          v-else-if="errorSaves > 0"
          style="background: red; color:white;padding:5px;"
        >
          <br /><br />
          <b>You may be required to re-enter information.</b>
        </div>
        <div v-else>
          <br /><br />All information has been saved.
        </div>
      </v-card-text>
      <v-card-actions v-if="pendingSaves == 0 || errorSaves > 0">
        <v-spacer/>
        <v-btn
          @click="unloadAndReload()"
          flat
          color="blue"
        >
          Refresh to Continue
        </v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      display: true
    }
  },
  computed: {
    ...mapGetters('userform', [
      'pendingSaves',
      'errorSaves'
    ])
  },
  methods: {
    unloadAndReload () {
      window.onbeforeunload = null
      this.$store.state.userform.handleBypass = true
      this.$router.go()
    }
  }
}
</script>
